import React from "react";
import History from "./History";

const CalHistory = () => {
  return <History initialTab="calories" />;
};

export default CalHistory;
